import * as types from './mutation-types'
import { defaultContextMenu } from './state'

export default {
  ['setCurrentRace'](state, payload) {
    state.currentRace = payload
  },
  ['addImageToCompares'](state, payload) {
    state.currentComparesImages = [...state.currentComparesImages, payload]
  },
  ['addImageToBaselineCompares'](state, payload) {
    state.currentBaselineComparesImages = [...state.currentBaselineComparesImages, payload]
  },
  ['removeImagesFromCompares'](state, payload) {
    state.currentComparesImages = state.currentComparesImages.filter(img => img.raceId !== payload)
    state.currentBaselineComparesImages = state.currentBaselineComparesImages.filter(img => img.raceId !== payload)
  },
  ['removeImageFromCompares'](state, payload) {
    state.currentComparesImages = state.currentComparesImages.filter(img => img.id !== payload)
    state.currentBaselineComparesImages = state.currentBaselineComparesImages.filter(img => img.id !== payload)
  },
  'updateImageBaselineCompare'(state, payload) {
    state.currentBaselineComparesImages = [...payload]
  },
  'changeOrdered'(state, payload) {
    state.ordered = payload
  },
  'changeIsShowComparesFooter'(state) {
    state.isShowComparesFooter = !state.isShowComparesFooter
  },
  [types.OPEN_COMPARE_PANEL](state) {
    state.isShowComparesFooter = true
  },
  [types.POLLING_CLEAR](state) {
    clearInterval(state.pollingImages.id)
  },
  [types.POLLING_INIT](state, payload) {
    state.pollingImages.id = payload
  },
  [types.POLLING_UPDATE_COLUMNS](state, payload) {
    state.pollingImages.columns = payload
  },
  [types.RESET_CONTEXT_MENU](state) {
    state.contextMenu = { ...defaultContextMenu }
  },
  [types.SET_CONTEXT_MENU](state, payload) {
    state.contextMenu = payload
  },
  [types.UPDATE_COLUMNS](state, payload) {
    state.columns = payload
  },
  [types.UPDATE_COLUMNS_DIALOG_VISIBILITY](state, payload) {
    state.columnsDialogVisibility = payload
  },
  [types.UPDATE_SAVED_RACES](state, payload) {
    state.savedRaces = payload
  },
}
